module.exports = __webpack_public_path__ + "img/中国电气装备集团.90c35d15.png";